<template lang="pug">
	.assets-add(v-show="showed" :class="{'direction-up': directionUp}" :style="position" v-pseudo-modal-name="'assets-add'")
		MultiLevelDropdownMenu(ref="dropdownMenu" :width="240" @change="addAsset($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'VersionAssetsAdd',
		mixins: [Screen],
		screen: {
			updateOn: [
			],
			events: {
				// addAssetCallback - добавление ассета выбранной группы (та же логика, что у плюса в заголовке группы во вкладке ассетов)
				"Show VersionAssetsAdd": function(el, assetsGroups, addAssetCallback) {

					this.assetsGroups = assetsGroups;
					this.addAssetCallback = addAssetCallback;

					this.anchorRect = el.getBoundingClientRect();

					this.directionUp = false;

					this.position.right = (document.body.clientWidth - this.anchorRect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - this.anchorRect.bottom) + 'px';

					this.collectData();

					// Кнопка находится внизу вкладки ассетов - если под ней не хватает места, меню открывается вверх
					this.$nextTick(() => this.updateDirection());

				},
				// Клик в любом месте кроме контента помеченного assets-add - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'assets-add') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {

			this.assetsGroups = {};
			this.addAssetCallback = null;
			this.anchorRect = null;

			return {
				directionUp: false,
				position: {
					right: 0,
					bottom: 0
				}
			};
		},
		methods: {
			collectData() {

				// Пункты меню - все группы ассетов, в которые можно добавить новый ассет (группы уже отсортированы по priority типа ассета).
				// Название, описание и иконка пункта - из метаданных типа ассета (metadata_asset_types)
				let assetsItems = _.map(_.filter(this.assetsGroups, assetsGroup => assetsGroup.isExtendable), assetsGroup => {

					let item = {title: assetsGroup.title, description: assetsGroup.menuDescription, width: 240, icon: assetsGroup.icon || 'fa-file-o', wordWrap: true, action: 'add-asset', data: {assetType: assetsGroup.type}};

					// Для картинок и видео - дополнительный уровень: загрузка файла с устройства или генерация с помощью ИИ
					if (assetsGroup.type === 'image' || assetsGroup.type === 'video') {

						item.opened = false;
						item.description = `Upload a new ${assetsGroup.type} file or generate a new asset using AI`;
						item.childs = [
							{title: 'Upload new file', description: `Upload a new ${assetsGroup.type} file from your device`, width: 240, icon: 'fa-upload', wordWrap: true, action: 'add-asset', data: {assetType: assetsGroup.type}},
							{title: 'Generate using AI', description: `Open the AI ${assetsGroup.type} generation screen and create a new asset`, width: 240, icon: 'fa-magic', wordWrap: true, action: 'generate-asset', data: {assetType: assetsGroup.type}}
						];

					}

					return item;

				});

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(assetsItems);

			},
			updateDirection() {

				let menuEl = this.$el.querySelector('.multi-level-dropdown-menu');

				if (!menuEl || !this.anchorRect) return;

				if (this.anchorRect.bottom + menuEl.offsetHeight + 10 <= window.innerHeight) return;

				this.directionUp = true;
				this.position.bottom = (document.body.clientHeight - this.anchorRect.top) + 'px';

			},
			addAsset(item, data) {

				let assetsGroup = this.assetsGroups[data.assetType];

				this.close();

				if (!assetsGroup || !this.addAssetCallback) return;

				// Меню картинок и видео состоит из двух уровней: загрузка файла или переход на экран генерации ИИ
				if (item.action !== 'add-asset' && item.action !== 'generate-asset') return;

				this.addAssetCallback(assetsGroup, item.action);

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.assets-add
		position: absolute
		margin-top: 1px
		user-select: none
		// Меню открывается из панели настроек и должно быть поверх неё (как другие всплывающие окна дашборда)
		z-index: 10000

		&.direction-up

			.multi-level-dropdown-menu.dropdown-menu
				top: auto
				bottom: 5px

</style>
